export const ARROW_DOWN_CHAR = '&#8595;';
export const ARROW_UP_CHAR = '&#8593;';

export const MALE_GENDER = 'Male';

export const apiPrefixUrl = 'https://raw.githubusercontent.com/maker27/wg_forge_frontend/master/data/';
